import * as React from 'react'
import {connect} from 'react-redux'
import './homePage_v1.less'
import Cards from './cards'
import {axios_} from "../../tools/axios_"
import ReactEcharts from 'echarts-for-react';
import { initPageNamesConfig, Utils } from '../../tools/utils'
import {Link} from 'react-router-dom'
import { QuestionCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
// import LocalData from "./localData.json"
// import * as Echarts from "echarts"
// 按需引入 ECharts 主模块
const echarts = require('echarts/lib/echarts');
// // 引入柱状图
// require('echarts/lib/chart/bar');
// // 引入提示框和标题组件
// require('echarts/lib/component/tooltip');
// require('echarts/lib/component/title');

const salesData = [];
for (let i = 0; i < 12; i += 1) {
  salesData.push({
    x: `${i + 1}月`,
    y: Math.floor(Math.random() * 1000) + 200,
  });
}

class HomePageV1 extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      charData:{},
      yesterdayCompanyFee:0,
      pageNamesConfig:{}, // 页面字段配置
    }
  }
  componentWillMount(){

  }
  componentDidMount(){
    Utils.insertChama();
    // 初始化页面展示字段（合作案）
    initPageNamesConfig('homePage', '', this.props.token).then(res => {
      if (res.data.status === 200) {
        this.setState({pageNamesConfig:res.data.data || {}})
      }
    })
    this.getData();
    this.getCompanyFee();
  }
  //昨日推广费
  getCompanyFee=()=>{
    axios_({
      url:"/api/intelligence/agencySettlement/companyAgencyYesterdayTotal",
      methods:"get",
      headers: {
        'access-token': this.props.token
      }
    }).then(res=>{
      if(res.status===200){
        this.setState({
          yesterdayCompanyFee:res.data.companyFee
        })
      }
    })
  };
  getData(){

    axios_({
      url:"dashboardInfo",
      methods:"get",
      headers: {
        'access-token': this.props.token
      }
    }).then((res)=>{
      if(res.data.status === 200){
        this.setState({
          charData:res.data.data
        })
      }
    })
  }
  getLineOption(data){
    const date = data.waveformsHeng || [];
    const val = data.waveformsZong || [];

    return {
      title: {
        text: '保费收入',
        textStyle: {
          fontSize: 20,
          color:'#000'
        },
        subtext: '横轴为日期,纵轴为保费收入',
        subtextStyle:{
          color:'#000'
        }
      },
      xAxis: {
        data: date,
        axisLabel:{
          color:'#000'
        }
      },
      grid: {
        top: 80,
        left: 0,
        right: 0,
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      yAxis: {
        axisLabel:{
          color:'#000'
        }
      },
      series: [{
        name: '保费收入',
        smooth: true,
        showSymbol: false,
        symbol: 'circle',
        type: 'line',
        symbolSize: 6,
        connectNulls: true,
        data: val,
        animationDuration: 2600,
        animationEasing: 'cubicInOut',
        itemStyle: {
          normal: {
            color: 'rgb(255, 70, 131)'
          }
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgb(255, 158, 68)'
            }, {
              offset: 1,
              color: 'rgb(255, 70, 131)'
            }])
          }
        },
      }
      ]
    }
  }
  getBarOption(data){
    const personal = data.histogramHeng || [];
    const val = data.histogramZong||[];
    return {
      title: {
        text: `昨日${this.state.pageNamesConfig.staff || '业务员'}保费TOP5`,
        left:'center',
        top:10,
        textStyle: {
          fontSize: 20,
          color:'#000'
        },
      },
      tooltip : {
        trigger: 'axis',
        axisPointer: { // 坐标轴指示器，坐标轴触发有效
          type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      legend: {
        left:0,
        data:['总保费','总佣金']
      },
      toolbox: {
        show : false,
        right:25,
        feature : {
          dataView : {show: true, readOnly: false},
          magicType : {show: true, type: ['line', 'bar']},
          restore : {show: true},
          saveAsImage : {show: true}
        },
        iconStyle:{
          normal:{
            borderColor:"#e03e38"
          },
          emphasis:{
            borderColor:"#c81f18"
          }
        }
      },
      calculable : true,
      xAxis : [
        {
          type : 'category',
          data : personal,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel:{
            color:'#000'
          }
        }
      ],
      yAxis : [
        {
          type : 'value',
          axisLabel:{
            color:'#000'
          }
        }
      ],
      series : [
        {
          name:'总保费',
          type:'bar',
          data:val,
          barWidth: '20%',
          animationDuration:3000,
          barGap:'50%',
          markPoint : {
            symbolSize:'40',
            label:{
              normal:{
                fontSize:10
              }
            },
            data : [
              {type : 'max', name: '最大值'},
              {type : 'min', name: '最小值'}
            ]
          },
          itemStyle:{
            normal:{
              color: "#c81f18",
            }
          }
        },
        /*
        {
          name:'总佣金',
          type:'bar',
          barWidth: '20%',
          data:val[1],
          animationDuration,
          itemStyle:{
            normal:{
              color: "#fb7671",
            }
          },
          markPoint : {
            symbolSize:'40',
            label:{
              normal:{
                fontSize:10
              }
            },
            data : [
              {type : 'max', name: '最大值'},
              {type : 'min', name: '最小值'}
            ]
          }
        }
        */
      ]
    }
  }
  getPieOption(data){
    // const product = data.pieChartHeng||[];
    const val = data.pieChartZong||[];
    return {
      // backgroundColor: '#2c343c',
      color: [
        "#c81f18",
        "#d4332c",
        "#e03e38",
        "#e75e58",
        "#fb7671"
      ],
      title: {
        text: '昨日产品销售情况TOP5',
        left: 'center',
        top: 10,
        textStyle: {
          fontSize: 20,
          color:'#000'
        },
        subtext: '注:仅展示保费规模前5的产品',
        subtextStyle:{
          fontSize:14,
          color:'#ff0000',
        }
      },
      tooltip : {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      // visualMap: {
      //   show: false,
      //   min: 80,
      //   max: 1600,
      //   inRange: {
      //     colorLightness: [0, 1]
      //   }
      // },
      // legend: {
      //   // top:'center',
      //   bottom:0,
      //   left:'center',
      //   // orient:'vertical',
      //   data: product,
      // },
      calculable: true,
      series : [
        {
          name:'保单分布情况(单)',
          type:'pie',
          radius : '55%',
          center: ['50%', '65%'],
          data:val.sort(function (a, b) { return a.value - b.value; }),
          roseType: 'radius',
          label: {
            normal: {
              show:true,
              textStyle: {
                // color: 'rgba(255, 255, 255, 0.3)'
                color:'#1a1a1a'
              }
            }
          },
          labelLine: {
            normal: {
              lineStyle: {
                color: '#999'
                // color:'#000'
              },
              smooth: 0.2,
              length: 10,
              length2: 20
            }
          },
          itemStyle: {
            normal: {
              // color: '#c23531',
              shadowBlur: 20,
              shadowColor: 'rgba(0, 0, 0, 0.3)'
            }
          },
          animationType: 'scale',
          animationEasing: 'elasticOut',
          animationDelay: function (idx) {
            return Math.random() * 200;
          }
        }
      ]
    }
  }
  /** 提示文字：保费收入*/
  getPolicyFeeTip = ()=>{
    return (
      <div className="homepage_question_tips">
        <p className="title">统计规则:</p>
        <p className="desc">按承保时间统计近7天，截止昨日24点统计，包含当前账户及所有下级机构团队</p>

        <p className="title marTop24">保费收入：</p>
        <p className="desc">统计时间段内已支付保费-已撤单保费-已退保保费</p>
      </div>
    )
  }
  /** 提示文字：昨日业务员保费TOP5*/
  getSalesmanTip = ()=>{
    return (
      <div className="homepage_question_tips">
        <p className="title">统计规则:</p>
        <p className="desc">按承保时间统计昨日0点～24时，包含当前账户及所有下级机构团队</p>

        <p className="title marTop24">业务员保费TOP5：</p>
        <p className="desc">统计时间段内已支付保费-已撤单保费-已退保保费，保费排名前五的业务员</p>
      </div>
    )
  }
  /** 提示文字：昨日产品销售情况TOP5*/
  getProductTip = ()=>{
    return (
      <div className="homepage_question_tips">
        <p className="title">统计规则:</p>
        <p className="desc">按承保时间统计昨日0点～24时，包含当前账户及所有下级机构团队</p>

        <p className="title marTop24">产品销售情况TOP5：</p>
        <p className="desc">统计时间段内已支付保费-已撤单保费-已退保保费，保费排名前五的保险产品</p>
      </div>
    )
  }

  render () {
    const {charData} = this.state;
    return (
      <div className="home_page">
        <header>
          <Cards
            count={ this.state.charData.yesterdayPolicyCount}
            type={1}
            title='昨日新单量（件）'/>
          <Cards
            count={this.state.charData.yesterdayPremiumSum}
            type={2}
            title='昨日保费（元）'/>
          <Cards
            count={this.state.yesterdayCompanyFee}
            type={3}
            title='昨日推广费（元）'/>
        </header>
        {/* <div id ="lineChar" style = {{width:"600px",height:"800px"}}></div>   */}

        <div className = "charts">
          <Popover trigger='hover' placement="bottom"  content={this.getPolicyFeeTip()}>
            <QuestionCircleOutlined
              style={{fontSize:'18px',position: 'absolute', marginLeft: '95px', top: '16px',zIndex:1000}} />
          </Popover>
          <ReactEcharts
            option={this.getLineOption(charData)}
            notMerge={true}
            lazyUpdate={true}
            style={{height: '350px', width: '100%'}}
          />
          <div className="barAndPie">
            <div className="bottomItem">
              <Popover trigger='hover' placement="bottom"  content={this.getSalesmanTip()}>
                <QuestionCircleOutlined
                  style={{fontSize:'18px',position: 'absolute', marginLeft: '105px', left: '50%', top: '4%',zIndex:1000}} />
              </Popover>
              <Link to={'/businessReport/orgReportM'} style={{width: '100%'}}>
                <ReactEcharts
                  option={this.getBarOption(charData)}
                  notMerge={true}
                  lazyUpdate={true}
                  style={{height: '350px', width: '100%'}}
                />
                <RightOutlined className="icon_right" />
              </Link>
            </div>

            <div className="bottomItem">
              <Popover trigger='hover' placement="bottom"  content={this.getProductTip()}>
                <QuestionCircleOutlined
                  style={{fontSize:'18px',position: 'absolute', marginLeft: '115px', left: '50%', top: '4%',zIndex:1000}} />
              </Popover>
              <Link to={'/businessReport/spuReportM'} style={{width: '100%'}}>
                <ReactEcharts
                  option={this.getPieOption(charData)}
                  notMerge={true}
                  lazyUpdate={true}
                  style={{height: '350px', width: '100%'}}
                />
                <RightOutlined className="icon_right" />
              </Link>
            </div>
          </div>
        </div>
        
      </div>
    );
  }
}

function mapState (state) {
  return {
    token: state.token
  }
}

export default connect(mapState)(HomePageV1)
